const AmberConnectIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <g clipPath="url(#clip0_214_89250)">
      <path
        d="M13.939 21.0311C13.939 20.2241 13.2847 19.5698 12.4777 19.5698C11.6707 19.5698 11.0164 20.2241 11.0164 21.0311V22.3222C11.0164 23.1293 11.6707 23.7835 12.4777 23.7835C13.2847 23.7835 13.939 23.1293 13.939 22.3222V21.0311Z"
        fill="#3F83F8"
      />
      <path
        d="M6.93776 19.303L6.33778 20.4463C5.96277 21.1609 6.23806 22.0442 6.95267 22.4193C7.66727 22.7943 8.55059 22.519 8.92561 21.8044L9.52559 20.6611C9.90061 19.9465 9.62531 19.0632 8.91071 18.6882C8.1961 18.3131 7.31278 18.5884 6.93776 19.303Z"
        fill="#3F83F8"
      />
      <path
        d="M4.12913 15.8801L3.06661 16.6137C2.40247 17.0722 2.23576 17.9822 2.69426 18.6464C3.15277 19.3105 4.06285 19.4772 4.72699 19.0187L5.78951 18.2852C6.45365 17.8267 6.62036 16.9166 6.16186 16.2525C5.70335 15.5883 4.79327 15.4216 4.12913 15.8801Z"
        fill="#3F83F8"
      />
      <path
        d="M3.23022 11.5463L1.94848 11.7019C1.14733 11.7991 0.576688 12.5274 0.673922 13.3286C0.771156 14.1297 1.49945 14.7003 2.3006 14.6031L3.58234 14.4476C4.38349 14.3503 4.95413 13.622 4.8569 12.8209C4.75966 12.0197 4.03137 11.4491 3.23022 11.5463Z"
        fill="#3F83F8"
      />
      <path
        d="M3.24637 6.83002C2.49178 6.54383 1.64807 6.92355 1.36188 7.67813C1.07569 8.43272 1.4554 9.27644 2.20999 9.56262L3.41722 10.0205C4.17181 10.3067 5.01552 9.92696 5.30171 9.17237C5.5879 8.41779 5.20819 7.57407 4.4536 7.28788L3.24637 6.83002Z"
        fill="#3F83F8"
      />
      <path
        d="M6.65719 3.11956C6.12201 2.5155 5.19848 2.45966 4.59442 2.99484C3.99036 3.53002 3.93452 4.45355 4.4697 5.05761L5.32591 6.02402C5.86109 6.62808 6.78462 6.68392 7.38868 6.14874C7.99274 5.61356 8.04858 4.69003 7.5134 4.08597L6.65719 3.11956Z"
        fill="#3F83F8"
      />
      <path
        d="M11.4018 1.41889C11.2086 0.635319 10.4168 0.15672 9.6332 0.349908C8.84963 0.543097 8.37103 1.33492 8.56422 2.11849L8.87329 3.37209C9.06648 4.15566 9.8583 4.63426 10.6419 4.44107C11.4254 4.24788 11.904 3.45606 11.7109 2.67249L11.4018 1.41889Z"
        fill="#3F83F8"
      />
      <path
        d="M13.5549 1.42186L13.2458 2.67546C13.0526 3.45903 13.5312 4.25085 14.3148 4.44404C15.0983 4.63723 15.8902 4.15863 16.0834 3.37506L16.3924 2.12145C16.5856 1.33788 16.107 0.546063 15.3234 0.352874C14.5399 0.159685 13.7481 0.638286 13.5549 1.42186Z"
        fill="#3F83F8"
      />
      <path
        d="M18.2992 3.12197L17.443 4.08838C16.9078 4.69244 16.9636 5.61598 17.5677 6.15116C18.1717 6.68634 19.0953 6.6305 19.6305 6.02644L20.4867 5.06003C21.0218 4.45597 20.966 3.53243 20.362 2.99726C19.7579 2.46208 18.8344 2.51791 18.2992 3.12197Z"
        fill="#3F83F8"
      />
      <path
        d="M21.7095 6.82912L20.5022 7.28698C19.7476 7.57317 19.3679 8.41689 19.6541 9.17148C19.9403 9.92606 20.784 10.3058 21.5386 10.0196L22.7458 9.56172C23.5004 9.27554 23.8801 8.43182 23.5939 7.67723C23.3078 6.92265 22.464 6.54294 21.7095 6.82912Z"
        fill="#3F83F8"
      />
      <path
        d="M21.7217 11.5439C20.9206 11.4466 20.1923 12.0173 20.0951 12.8184C19.9978 13.6196 20.5685 14.3479 21.3696 14.4451L22.6514 14.6007C23.4525 14.6979 24.1808 14.1273 24.278 13.3261C24.3753 12.5249 23.8046 11.7967 23.0035 11.6994L21.7217 11.5439Z"
        fill="#3F83F8"
      />
      <path
        d="M20.8259 15.8782C20.1617 15.4199 19.2516 15.5867 18.7932 16.2509C18.3349 16.9152 18.5017 17.8252 19.1659 18.2836L20.2286 19.0169C20.8928 19.4753 21.8029 19.3085 22.2612 18.6442C22.7196 17.98 22.5528 17.07 21.8885 16.6116L20.8259 15.8782Z"
        fill="#3F83F8"
      />
      <path
        d="M18.0167 19.3069C17.6417 18.5923 16.7584 18.317 16.0438 18.6921C15.3292 19.0671 15.0539 19.9504 15.4289 20.665L16.0289 21.8083C16.4039 22.5229 17.2872 22.7982 18.0018 22.4232C18.7164 22.0481 18.9917 21.1648 18.6167 20.4502L18.0167 19.3069Z"
        fill="#3F83F8"
      />
      <path
        d="M13.2794 16.908C13.2794 16.465 12.9203 16.106 12.4774 16.106C12.0344 16.106 11.6754 16.465 11.6754 16.908V17.6163C11.6754 18.0593 12.0344 18.4184 12.4774 18.4184C12.9203 18.4184 13.2794 18.0593 13.2794 17.6163V16.908Z"
        fill="#3F83F8"
      />
      <path
        d="M9.43701 15.9585L9.10762 16.5862C8.90178 16.9784 9.05288 17.4632 9.4451 17.6691C9.83731 17.8749 10.3221 17.7238 10.528 17.3316L10.8574 16.7039C11.0632 16.3117 10.9121 15.8269 10.5199 15.6211C10.1277 15.4152 9.64285 15.5663 9.43701 15.9585Z"
        fill="#3F83F8"
      />
      <path
        d="M7.89559 14.0801L7.31224 14.4828C6.94772 14.7345 6.85623 15.234 7.10788 15.5985C7.35953 15.963 7.85903 16.0545 8.22355 15.8029L8.8069 15.4001C9.17142 15.1485 9.26291 14.649 9.01126 14.2845C8.75961 13.9199 8.2601 13.8284 7.89559 14.0801Z"
        fill="#3F83F8"
      />
      <path
        d="M7.40148 11.7038L6.69828 11.7891C6.25856 11.8425 5.94536 12.2422 5.99873 12.6819C6.0521 13.1216 6.45182 13.4348 6.89154 13.3815L7.59474 13.2961C8.03446 13.2428 8.34766 12.843 8.29429 12.4033C8.24092 11.9636 7.8412 11.6504 7.40148 11.7038Z"
        fill="#3F83F8"
      />
      <path
        d="M7.41065 9.11468C6.99649 8.95761 6.53341 9.16602 6.37633 9.58018C6.21925 9.99434 6.42766 10.4574 6.84182 10.6145L7.50414 10.8657C7.9183 11.0228 8.38138 10.8144 8.53846 10.4002C8.69553 9.98603 8.48713 9.52296 8.07297 9.36588L7.41065 9.11468Z"
        fill="#3F83F8"
      />
      <path
        d="M9.28283 7.07712C8.98909 6.74558 8.48221 6.71493 8.15066 7.00867C7.81912 7.30241 7.78847 7.8093 8.08221 8.14084L8.55195 8.67104C8.84569 9.00258 9.35258 9.03323 9.68412 8.73949C10.0157 8.44575 10.0463 7.93886 9.75257 7.60732L9.28283 7.07712Z"
        fill="#3F83F8"
      />
      <path
        d="M11.8876 6.14326C11.7816 5.7132 11.347 5.45051 10.9169 5.55655C10.4868 5.66258 10.2241 6.09717 10.3302 6.52724L10.4997 7.215C10.6058 7.64507 11.0404 7.90775 11.4704 7.80172C11.9005 7.69569 12.1632 7.26109 12.0572 6.83102L11.8876 6.14326Z"
        fill="#3F83F8"
      />
      <path
        d="M13.0691 6.14633L12.8995 6.83409C12.7935 7.26415 13.0562 7.69875 13.4862 7.80478C13.9163 7.91082 14.3509 7.64813 14.4569 7.21807L14.6265 6.53031C14.7325 6.10024 14.4698 5.66564 14.0398 5.55961C13.6097 5.45358 13.1751 5.71626 13.0691 6.14633Z"
        fill="#3F83F8"
      />
      <path
        d="M15.6721 7.07994L15.2023 7.61014C14.9086 7.94168 14.9392 8.44857 15.2708 8.74231C15.6023 9.03604 16.1092 9.0054 16.4029 8.67385L16.8727 8.14366C17.1664 7.81211 17.1358 7.30522 16.8042 7.01149C16.4727 6.71775 15.9658 6.7484 15.6721 7.07994Z"
        fill="#3F83F8"
      />
      <path
        d="M17.544 9.11381L16.8817 9.365C16.4675 9.52208 16.2591 9.98516 16.4162 10.3993C16.5733 10.8135 17.0363 11.0219 17.4505 10.8648L18.1128 10.6136C18.527 10.4565 18.7354 9.99346 18.5783 9.5793C18.4212 9.16514 17.9582 8.95673 17.544 9.11381Z"
        fill="#3F83F8"
      />
      <path
        d="M17.5504 11.7006C17.1107 11.6472 16.711 11.9604 16.6576 12.4001C16.6042 12.8398 16.9174 13.2396 17.3572 13.2929L18.0604 13.3783C18.5001 13.4316 18.8998 13.1184 18.9532 12.6787C19.0065 12.239 18.6933 11.8393 18.2536 11.7859L17.5504 11.7006Z"
        fill="#3F83F8"
      />
      <path
        d="M17.059 14.0792C16.6944 13.8276 16.1949 13.9192 15.9433 14.2837C15.6917 14.6483 15.7833 15.1478 16.1479 15.3994L16.7309 15.8017C17.0955 16.0533 17.5949 15.9617 17.8465 15.5972C18.0981 15.2326 18.0065 14.7331 17.642 14.4815L17.059 14.0792Z"
        fill="#3F83F8"
      />
      <path
        d="M15.5174 15.9628C15.3116 15.5706 14.8268 15.4195 14.4345 15.6254C14.0423 15.8312 13.8912 16.316 14.0971 16.7082L14.4262 17.3354C14.6321 17.7277 15.1169 17.8788 15.5091 17.6729C15.9013 17.4671 16.0524 16.9823 15.8466 16.5901L15.5174 15.9628Z"
        fill="#3F83F8"
      />
    </g>
    <defs>
      <clipPath id="clip0_214_89250">
        <rect width="24" height="24" fill="white" transform="translate(0.454102)" />
      </clipPath>
    </defs>
  </svg>
);

export default AmberConnectIcon;
